export default {
  name: 'AddressSummary',

  // language=HTML (for PhpStorm)
  template: `
    <div class="address-fields">
      <template v-if="address.street">
        {{ address.street }} <br>
      </template>
      <template v-if="address.street2">
        {{ address.street2 }} <br>
      </template>
      {{ address.city }}, {{ address.state }} {{ address.zip }}
    </div>
  `,

  props: {
    address: {
      type: Object,
      required: true,
      default() {
        return {
          street: null,
          street2: null,
          city: null,
          state: null,
          zip: null,
        }
      },
    },
  },
}
